import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea, Tip } from "@/components/Callouts";

export default function EdSheeran5() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "5");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/05-symmetry.png"
          caption="Jason's chord chart for Symmetry"
        />
      </Section>

      <Section title="The Hook — Cm11">
        <RomanNumeralAnalysis
          label="Hook · C minor — Cm11"
          chords={[
            {
              chord: "Cm11",
              rn: "i11",
              function: "Tonic",
              pitches: ["C3", "Eb3", "G3", "Bb3", "D4", "F4"],
            },
          ]}
        />
        <Tip>
          A minor 11 chord is a minor 7 with a 9th and an 11th stacked on top. Count the thirds going
          up: C–E♭–G–B♭–D–F. Six notes, one chord, total atmosphere.
        </Tip>
      </Section>

      <Section title="Chorus">
        <RomanNumeralAnalysis
          label="Chorus · C minor"
          chords={[
            { chord: "Cm", rn: "i", function: "Tonic", pitches: ["C3", "Eb3", "G3", "C4"] },
            { chord: "Eb", rn: "♭III", function: "Mediant", pitches: ["Eb3", "G3", "Bb3", "Eb4"] },
            { bar: true },
            { chord: "Bb", rn: "♭VII", pitches: ["Bb2", "D3", "F3", "Bb3"] },
            { chord: "Ab", rn: "♭VI", function: "Submediant", pitches: ["Ab2", "C3", "Eb3", "Ab3"] },
          ]}
        />
        <KeyIdea title="Special moment">
          i–♭III–♭VII–♭VI: all four chords are diatonic to C natural minor (C D E♭ F G A♭ B♭) —
          no borrowed notes needed.
        </KeyIdea>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="32sPcsb9ClQ" />
      </Section>
    </LessonShell>
  );
}
